/* Small sitewide behaviours for the ICT theme. */
(function () {
  // Crisp live chat: on phones, lift its button and greeting bubble above the bottom tab bar
  // (.ict-dock) so they don't cover the Account tab. Crisp's class names are generated, so find
  // its fixed-position elements inside #crisp-chatbox and offset them by the dock height.
  function liftCrisp() {
    var box = document.getElementById('crisp-chatbox');
    var dock = document.querySelector('.ict-dock');
    if (!box || !dock) return;
    var dockVisible = getComputedStyle(dock).display !== 'none' && dock.getBoundingClientRect().height > 0;
    var lift = dockVisible ? Math.round(window.innerHeight - dock.getBoundingClientRect().top + 8) : 0;
    box.querySelectorAll('*').forEach(function (el) {
      if (getComputedStyle(el).position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.width >= window.innerWidth - 2 && r.height >= window.innerHeight - 2) return; // full-screen chat window
      if (!el.dataset.ictBottom) el.dataset.ictBottom = parseFloat(getComputedStyle(el).bottom) || 0;
      el.style.setProperty('bottom', (Number(el.dataset.ictBottom) + lift) + 'px', 'important');
    });
  }
  var tries = 0;
  var timer = setInterval(function () {
    if (document.getElementById('crisp-chatbox')) {
      liftCrisp();
      new MutationObserver(function () { window.requestAnimationFrame(liftCrisp); })
        .observe(document.getElementById('crisp-chatbox'), { childList: true, subtree: true });
      window.addEventListener('resize', liftCrisp);
      clearInterval(timer);
    } else if (++tries > 40) clearInterval(timer);
  }, 500);
})();

/* Product-card brand names: the card is already a link, so the brand uses data-href instead of a nested <a>. */
(function () {
  function go(e) {
    var b = e.target.closest && e.target.closest('.ict-jd-card__meta[data-href]');
    if (!b) return;
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    e.preventDefault();
    e.stopPropagation();
    if (e.metaKey || e.ctrlKey) window.open(b.dataset.href, '_blank');
    else location.href = b.dataset.href;
  }
  document.addEventListener('click', go, true);
  document.addEventListener('keydown', go, true);
})();

/* Crisp: no "Ask questions" tooltip and no chat popping open by itself — it stays open only when the
   shopper taps the chat bubble or one of our "chat with us" buttons. Crisp fires chat:opened for its own
   automatic opens too, so intent comes from a recent tap, not from that event.
   (The welcome message / triggers themselves are switched in the Crisp dashboard.) */
(function () {
  window.$crisp = window.$crisp || [];
  window.$crisp.push(['config', 'availability:tooltip', [false]]);
  var tappedAt = 0;
  var userOpened = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('#crisp-chatbox, [data-ict-empty-chat], [data-ict-live-chat], [data-ict-chat]')) tappedAt = Date.now();
  }, true);
  function guard() {
    if (Date.now() - tappedAt < 2500) { userOpened = true; return; }
    if (!userOpened) window.$crisp.push(['do', 'chat:close']);
  }
  window.$crisp.push(['on', 'chat:opened', guard]);
  window.$crisp.push(['on', 'chat:closed', function () { userOpened = false; }]);
  window.$crisp.push(['on', 'message:received', function () {
    if (window.$crisp.is && window.$crisp.is('chat:opened')) guard();
  }]);
})();

/* Links marked data-ict-chat (product page "Price match" / "Chat with us") open the Crisp chat, pre-filling
   data-ict-chat-msg when given. Before Crisp has loaded they behave as plain links to the contact page. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-ict-chat]');
  if (!a || !window.$crisp || !window.$crisp.is) return;
  e.preventDefault();
  var msg = a.getAttribute('data-ict-chat-msg');
  if (msg) window.$crisp.push(['set', 'message:text', [msg]]);
  window.$crisp.push(['do', 'chat:open']);
});

/* Product "Share" on phones: use the native share sheet (iOS / Android); otherwise copy the link. */
(function () {
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'ict-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 1800);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[aria-controls^="ShareDrawer-"]');
    if (!a) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var url = a.getAttribute('href') || location.href;
    var title = document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast('Link copied'); }, function () { window.prompt('Copy this link', url); });
    } else {
      window.prompt('Copy this link', url);
    }
  }, true);
})();

/* Price filter slider: keeps the two range handles and the Min / Max fields in sync */
(function () {
  function fmt(n) { return 'K' + Math.round(n).toLocaleString('en-US'); }
  function setup(box) {
    var form = box.closest('form');
    var rMin = box.querySelector('[data-range-min]'), rMax = box.querySelector('[data-range-max]');
    var nums = form.querySelectorAll('input[type=number]');
    var nMin = nums[0], nMax = nums[1];
    var max = +box.dataset.max || 0;
    if (!max) { box.hidden = true; return; }
    var step = Math.max(1, Math.pow(10, Math.max(0, String(Math.round(max / 100)).length - 1)));
    rMin.step = rMax.step = step;
    var fill = box.querySelector('[data-range-fill]');
    var lMin = box.querySelector('[data-range-label-min]'), lMax = box.querySelector('[data-range-label-max]');
    function paint() {
      var a = +rMin.value, b = +rMax.value;
      fill.style.left = (a / max * 100) + '%';
      fill.style.right = (100 - b / max * 100) + '%';
      lMin.textContent = fmt(a); lMax.textContent = fmt(b);
    }
    function fromRange(which) {
      var a = +rMin.value, b = +rMax.value;
      if (a > b - step) { if (which === 'min') rMin.value = a = b - step; else rMax.value = b = a + step; }
      nMin.value = a > 0 ? a : '';
      nMax.value = b < max ? b : '';
      paint();
    }
    function fromNumber() {
      var a = parseInt(nMin.value, 10) || 0, b = parseInt(nMax.value, 10) || max;
      rMin.value = Math.min(a, max); rMax.value = Math.min(Math.max(b, a), max);
      paint();
    }
    rMin.addEventListener('input', function () { fromRange('min'); });
    rMax.addEventListener('input', function () { fromRange('max'); });
    nMin.addEventListener('input', fromNumber);
    nMax.addEventListener('input', fromNumber);
    if (nMin.value || nMax.value) fromNumber(); else paint();
  }
  document.querySelectorAll('[data-ict-range]').forEach(setup);
})();

/* Product page: show the "Save K…" amount as a red pill over the top-left of the product image.
   The label comes from .ict-you-save under the price (re-rendered on variant change), so watch it. */
(function () {
  function sync(section) {
    var gallery = section.querySelector('media-gallery');
    if (!gallery) return;
    var src = section.querySelector('.product__price .ict-you-save');
    var pill = gallery.querySelector('.ict-save-pill');
    var label = src && src.getAttribute('data-label');
    if (!label) { if (pill) pill.remove(); return; }
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'ict-save-pill';
      gallery.appendChild(pill);
    }
    pill.textContent = label;
  }
  document.querySelectorAll('.product__info').forEach(function (info) {
    var section = info.closest('.shopify-section') || document;
    sync(section);
    var price = info.querySelector('.product__price');
    if (price) new MutationObserver(function () { sync(section); }).observe(price, { childList: true, subtree: true, attributes: true });
  });
})();

/* Product add-ons (snippets/ict-product-addons): one tap adds the accessory and opens the cart drawer */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ict-addon]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var label = btn.innerHTML;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-ict-addon')), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('cart-count').forEach(function (c) { var n = c.querySelector('[aria-hidden]') || c; n.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') setTimeout(function () { drawer.show(); }, 350);
        btn.classList.add('is-added');
        btn.textContent = btn.getAttribute('data-added') || 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; btn.disabled = false; }, 2500);
      })
      .catch(function () { btn.innerHTML = label; btn.disabled = false; });
  });
})();

(function () {
  // Keep shoppers in their language: menus and section settings store full https://ict.com.mm/… or
  // root-relative links, which Shopify doesn't prefix with the locale (/my/), so rewrite them.
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return;
  var skip = /^\/(cdn|checkouts?|account|apps|tools|services|admin|a\/|cart\/(add|change|update|clear))/;
  function localize(a) {
    if (!a.href || a.hasAttribute('hreflang') || a.dataset.ictLocalized) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return; }
    if (u.origin !== location.origin || u.pathname.indexOf(root) === 0 || skip.test(u.pathname)) return;
    u.pathname = root + u.pathname.replace(/^\//, '');
    a.href = u.toString();
    a.dataset.ictLocalized = '1';
  }
  function run(scope) { (scope || document).querySelectorAll('a[href]').forEach(localize); }
  run();
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches('a[href]')) localize(n); run(n); } });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
